import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserFilterValues } from "../types/user";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: UserFilterValues = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const users = createSlice({
  name: "users",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
      state.searchValue.organizationId = action.payload.organizationId;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = users.actions;

export const selectSearchValue = (state: { users: UserFilterValues }) =>
  state?.users?.searchValue;
export const selectIsActive = (state: { users: UserFilterValues }) =>
  state?.users?.isActive;
export default users.reducer;
